import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'output']
  static values = { base: String }

  urlFriendly = () => {
    const urlFriendlyValue = this.inputTarget.value.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '')
    this.outputTarget.innerHTML = '/' + urlFriendlyValue
  }

  copyText = (event) => {
    event.stopPropagation()
    event.preventDefault()

    const text = this.baseValue + this.outputTarget.innerHTML
    navigator.clipboard.writeText(text)
  }
}
